// pages/src/LemmaPlayUtils.js

import React from 'react';
import './LemmaPlayUtils.css';
// 1. Play audio file by URL
export const playAudioURL = (audioUrl) => {
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  if (!audioUrl) {
    alert("No audio available!");
    return;
  }
  const prefixpath = baseHostUrl;//"http://localhost:80"
  const finalaUrl = prefixpath ? `${prefixpath}/${audioUrl}` : audioUrl;
  const audio = new Audio(finalaUrl);
  audio.playbackRate = 0.9; 
  audio.play().catch(err => {
    console.error("Audio playback failed:", err);
  });
};

// 2. Speak text using browser Speech API
export const speakText = (headword) => {
  if (!headword) {
    alert("No text available to speak!");
    return;
  }

  const utterance = new SpeechSynthesisUtterance(headword);
  utterance.rate = 1;
  utterance.pitch = 0.7;

  const isChinese = /[\u4e00-\u9fff]/.test(headword);
  const voices = window.speechSynthesis.getVoices();
  const matchedVoice = voices.find(voice =>
    isChinese ? voice.lang.startsWith('zh') : voice.lang.startsWith('en')
  );

  if (matchedVoice) {
    utterance.voice = matchedVoice;
  }

  speechSynthesis.speak(utterance);
};

// 3. Button to play audio URL
export const PlayAudioButton = ({ url }) => (
  <button
    onClick={() => playAudioURL(url)}
    className="speaker-button"
    // style={{
    //   border: 'none',
    //   background: 'transparent',
    //   cursor: 'pointer',
    //   fontSize: '18px',
    //   padding: '5px 15px'
    // }}
  >
    🔊
  </button>
);

// 4. Button to speak text
export const SpeakTextButton = ({ aidtext }) => (
  <button
    onClick={() => speakText(aidtext)}
    className="speaker-button"
    // style={{
    //   border: 'none',
    //   background: 'transparent',
    //   cursor: 'pointer',
    //   fontSize: '18px',
    //   padding: '5px 15px'
    // }}
  >
    🔊
  </button>
);



  export const LemmaAudioPlayer = ({aidurl, aidtext, prefixpath = ''}) => {
    if (!aidurl && !aidtext) {
      console.error("Missing band, aidurl, or aidtext!");
      return null;  // ❗ Must return null, not just return; (important for React)
    }
    let band = '';
    if (typeof aidurl === 'string') {
      const parts = aidurl.split('/');
      band = parts.length > 0 ? parts[0] : '';
      if (band === 'cmnpe'){
         band = parts.length > 1 ? parts[1] : '';
      }
    }
    const bandList = ['1k', '2k', '3k', '4k', '5k', '6k', '7k','8k', '9k', '10k',
      '11k', '12k', '13k', '14k', '15k', '16k', '17k','18k', '19k', '20k',
      '21k', '22k', '23k', '24k', '25k'
    ];
    
  //TODO: for cmnbook. the bandList could be ['1','2','3'....'8']
    if (bandList.includes(band)) {
        // Audio player
        const finalUrl = prefixpath ? `${prefixpath}/${aidurl}` : aidurl;
        return <PlayAudioButton url={finalUrl} />;
      } else {
        // Speak Text
        return <SpeakTextButton aidtext={aidtext} />;
      }
  };


  export const BookAudioPlayer = ({aidurl, aidtext, prefixpath = ''}) => {
    if (!aidurl && !aidtext) {
      console.error("Missing band, aidurl, or aidtext!");
      return null;  // ❗ Must return null, not just return; (important for React)
    }
    let band = '';
    if (typeof aidurl === 'string') {
      const parts = aidurl.split('/');
      band = parts.length > 0 ? parts[0] : '';
    }
    const bandList = ['1', '2', '3', '4', '5', '6', '7','8'];
  //TODO: for cmnbook. the bandList could be ['1','2','3'....'8']
    if (bandList.includes(band)) {
        // Audio player
        const finalUrl = prefixpath ? `${prefixpath}/${aidurl}` : aidurl;
        return <PlayAudioButton url={finalUrl} />;
      } else {
        // Speak Text
        return <SpeakTextButton aidtext={aidtext} />;
      }
  };